import router from '../router'
import { event } from 'vue-gtag'
import type { Dictionary } from 'vue-gtag'

/* eslint @typescript-eslint/no-explicit-any: 0 */
const eventTemplate = (): Dictionary<string | symbol | null | undefined> => {
  return {
    page_title: router.currentRoute.value.name,
    parameters: router.currentRoute.value.query ?
      Object.entries(router.currentRoute.value.query).map(
        ([key, value]) => ((value && value.length) ? `${key}_${value}` : null)
      ).filter((el) => el).join('_') : null,
    page_path: router.currentRoute.value.path,
    user_id: (window as any).gon.currentUser.id,
    admin: (window as any).gon.currentUser.admin,
    company_uuid: Array.isArray(router.currentRoute.value.params.company_uuid) ?
      router.currentRoute.value.params.company_uuid.join('-') : router.currentRoute.value.params.company_uuid,
    distributer_uuid: (window as any).gon.currentUser.distributer_uuid
  }
}

const gaEvent = (eventName: string, customEventValues: Dictionary<string | null>): void => {
  event(eventName, {
    ...eventTemplate(),
    ...customEventValues
  })
}

export const actionEvent = (actionName: string, actionValues: string | null = null): void => {
  gaEvent('action', { action_name: actionName, action_values: actionValues })
}
